import { Component, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * The Centraleyes full-page loader the Collection lobby shows on a cold entry (refresh / direct URL
 * / after login), packaged so any screen can reuse it. The host screen decides when to show and
 * hide it — see NavigationContextService.claimColdLoad().
 *
 * The bar creeps on its own because these screens have no per-API progress counter to bind to; it
 * stops short of the end and the screen removes the loader once its data has actually landed.
 */
@Component({
  selector: 'cygov-full-page-loader',
  templateUrl: './full-page-loader.component.html',
  styleUrls: ['./full-page-loader.component.scss'],
  standalone: false,
})
export class FullPageLoaderComponent implements OnInit, OnDestroy {
  // text under the bar, e.g. 'Loading AI Tasks'
  @Input() caption = '';

  // 'logo' is the animated Centraleyes mark cold-load screens show; 'mascot' is the AI robot the
  // splash and login screens show. Default keeps every existing call site rendering as before.
  @Input() icon: 'logo' | 'mascot' = 'logo';

  readonly mascotImg = 'assets/images/robot.png';

  progress = 0;
  private progressTimer: ReturnType<typeof setInterval>;

  // eases toward CREEP_CEILING so the bar keeps moving without ever claiming to be finished
  private static readonly CREEP_CEILING = 92;
  private static readonly CREEP_INTERVAL_MS = 400;

  ngOnInit(): void {
    this.progressTimer = setInterval(() => {
      const remaining = FullPageLoaderComponent.CREEP_CEILING - this.progress;
      this.progress = this.progress + Math.max(1, remaining / 10);
      if (this.progress >= FullPageLoaderComponent.CREEP_CEILING) {
        this.progress = FullPageLoaderComponent.CREEP_CEILING;
        clearInterval(this.progressTimer);
      }
    }, FullPageLoaderComponent.CREEP_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    clearInterval(this.progressTimer);
  }
}
